import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const SummaryTandC = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Changes to These Terms</h3>

      <p>
        We may update these Terms & Conditions from time to time to reflect
        changes to our services, platform features, business practices, legal
        requirements, or other operational needs. When these Terms & Conditions
        are updated, the revised version will be posted on this page and the
        &quot;Last Updated&quot; date will be changed accordingly.
      </p>

      <p>
        Where changes are material, we may provide additional notice through the
        platform, by email, or through another appropriate method where
        reasonably appropriate or required by applicable law.
      </p>

      <p>
        Updated Terms & Conditions will take effect on the date specified in the
        revised Terms or accompanying notice. Your continued use of the
        applicable website, platform, or services after the updated Terms take
        effect constitutes acceptance of the revised Terms & Conditions, except
        where additional consent is required by applicable law.
      </p>

      <p>
        Changes to these Terms & Conditions will not override specific terms in
        an existing written agreement, proposal, subscription arrangement, or
        other agreement with Yoda Safety Services unless permitted by that
        agreement or otherwise agreed by the applicable parties.
      </p>

      <p>
        We encourage users to review these Terms & Conditions periodically to
        remain informed about the terms that apply to their use of Yoda Safety
        Services.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default SummaryTandC;
